
import { update } from 'lodash'
import * as types from '../mutation-types'

export const state = {

	/*
	|--------------------------------------------------------------------------
	| Versão do Aplicativo
	|--------------------------------------------------------------------------
	|
	| Versão do aplicativo mostrado nas páginas
	|
	|
	|
	*/

	versao : '',

	/*
	|--------------------------------------------------------------------------
	| Versão do Aplicativo
	|--------------------------------------------------------------------------
	|
	| Versão do aplicativo mostrado nas páginas
	|
	|
	|
	*/

	fone_suporte : 'Whatsapp (21) 97421-7212',

	/*
	|--------------------------------------------------------------------------
	| Configuração Global do DatePinker
	|--------------------------------------------------------------------------
	|
	| Editando estas configurações todos os componentes de data do sistema
	| são alterados, desta forma tais componentes dependem de tal configuração
	| para funcinar.
	|
	*/

	configCal : {
          bootrapTema: true,
          calIconButton: 'fa fa-calendar',
          calButton : true,
          clearButton: true,
          clearIconButton: 'fa fa-times',
          format : 'dd-MM-yyyy'
   },

	 /*
	 |--------------------------------------------------------------------------
	 |  Aciona o Carregamento Global
	 |--------------------------------------------------------------------------
	 |
	 |  Este Array controla o mostrar de cada carregamento global no sistema.
	 |	Deve sepre ser FALSE inicialmente.
	 |	Utilizada no componente de carregamento geral do sistema
	 |
	 */

	 loading : {
		 	 page: false,
			 ajax: false
	 },

	 /*
	 |--------------------------------------------------------------------------
	 | Habilitação do Modulo de Load Global Automático em Todas as Chamadas Ajax
	 |--------------------------------------------------------------------------
	 |
	 |  Em todas as chamadas ajax mostrar o carregamento global auto. com exceções
 	 |  loadGlobal.enable = habilita ou desabilita o load Global em todo sistema
	 |	loadGlobal.show = utilizar o load Global ou não no carregamento de uma função
	 |
	 */

	 loadGlobal: {
			 enable: true,
			 show: true
	 },

	 /*
	 |--------------------------------------------------------------------------
	 | 	Configurações do usuário na conta
	 |--------------------------------------------------------------------------
	 |
	 |  Algumas configurações podem ser editadas na conta do usuário,
 	 |  esta função permite aumentar o alcance do projeto, ou seja, outros
	 |	profissionais além dos psicopedagogos poderam utilizar o software.
	 |
	 */

	 user_config: {

			// Termo utilizado para títulos nas telas do sistema
		  termo_titulo : {
					sing: '', // default: 'Psicopedagógico',
					plural: '', // default: 'Psicopedagógicos'
			},

			// Muda o termo em todas as telas no sistema
			termo_paciente : {
					sing: '', // default:'Paciente',
					plural: '', // default:'Pacientes'
			},

			// Muda o termo em todas as telas no sistema
			termo_atendimento : {
					sing: '', // default:'Atendimento',
					plural: '', // default:'Atendimentos'
			},

			// opções que aparecem no menu Superior
			menu_nav_bar : {
					pacientes:'', // default: true,
					atendimentos: '', // default:true,
					escolas: '', // default:true,
					responsaveis: '', // default:true,
					testes:'', // default: true,
					documentos:'', // default: true
			},

			// habilita e desabilita modulos no sistema
			modulos : {
				financeiro:'', // default: true
			}


	 },

	 /*
	 |--------------------------------------------------------------------------
	 | 	Arrays com opções de configurações para termos
	 |--------------------------------------------------------------------------
	 |
	 |  Estas opções ficarão disponiveis para que usuário possa configurar
 	 |  sua conta com as preferências que achar melhor.
	 |  No futuro implementar via banco de dados (cadastrando no adm)
	 |
	 */

	 termos : {

			 paciente :[
						{ sing: 'Paciente', plural: 'Pacientes' },
						{ sing: 'Cliente', plural: 'Clientes' },
						{ sing: 'Aluno', plural: 'Alunos' },
						{ sing: 'Aprendente', plural: 'Aprendentes' },
						{ sing: 'Estudante', plural: 'Estudantes' }
				],

			 titulo :[
					 { sing: 'Psicopedagógico', plural: 'Psicopedagógicos' },
					 { sing: 'Neuropsicopedagógico', plural: 'Neuropsicopedagógicos' },
					 { sing: 'Neuropsicológico', plural: 'Neuropsicológicos' },
					 { sing: 'Psicológico', plural: 'Psicológicos' },
					 { sing: 'Fonoaudiológico', plural: 'Fonoaudiológicos' },
					 { sing: 'Clínico', plural: 'Clínicos' },
					 { sing: 'Institucional', plural: 'Institucionais' }
		 	 ],

			 atendimento :[
					 { sing: 'Atendimento', plural: 'Atendimentos' },
					 { sing: 'Sessão', plural: 'Sessões' },
					 { sing: 'Consulta', plural: 'Consultas' }
			 ]
	 },

	 //URL do admin para download e outros recursos
	 urlApiAdm : 'https://adm.psiqueasy.com.br/'

}

//---------------------------------------------------------------------

export const getters = {

		modulos : state => state.user_config.modulos,

		menu_nav_bar : state => state.user_config.menu_nav_bar,

		termo_paciente : state => state.user_config.termo_paciente,
		termo_titulo : state => state.user_config.termo_titulo,
		termo_atendimento : state =>  state.user_config.termo_atendimento,
		termos_paciete : state => state.termos.paciente,
		termos_titulo : state => state.termos.titulo,
		termos_atendimento : state => state.termos.atendimento


}

//---------------------------------------------------------------------

export const actions = {

	updateVersao({ commit }, payload){
		commit(types.SET_VERSAO, payload)
	},

	// Para Habilitar ou desabilitar LOAD GLOBAL temporariamente (true ou false)
	loadGlobal({ commit }, payload){
			commit(types.SET_LOAD_GLOBAL, payload)
	},

	// limpamdo configuração de usuário
	clearConfigUser({commit}){

			let l_config = {
					menu_nav_bar: '',
					termo_titulo: '',
					termo_paciente: '',
					termo_atendimento: '',
					modulos: ''
			}
			commit(types.SET_CONFIG, { config: l_config })
	},

	// carregando a configuração do usuario
	async loadConfigUser({ dispatch, commit }){

			 try {
					const { data } = await axios.get('/api/settings/config')
					// console.log('carregou');
					commit(types.SET_CONFIG, { config: data })

				} catch (e) {
						dispatch('alert/erroAoCarregar', 'a Configuração', { root: true })
				}

	},

	// setar configuração do usuário
	// setConfig({ commit } , { n_config }){
	// 	commit(types.SET_CONFIG, { config: n_config })
	// },

	// o array {config} deve vir completo com todas as configurações
	async salvarConfig({ dispatch, commit } , { config }){

			try {
					const { data } = await axios.post('/api/settings/config', config)
					commit(types.SET_CONFIG, { config: data })
			} catch (e) {
					dispatch('alert/erroAoSalvar', null, { root: true })
			}

			// dispatch('auth/fetchUser', null, { root:true })

	}


}


//---------------------------------------------------------------------
export const mutations = {

	// setando algumas configurações
	[types.SET_CONFIG](state, { config }){
			// console.log('muttation SET_CONFIG' + config);
			state.user_config.menu_nav_bar = config.menu_nav_bar
			state.user_config.termo_titulo = config.termo_titulo
			state.user_config.termo_paciente = config.termo_paciente
			state.user_config.termo_atendimento = config.termo_atendimento
			state.user_config.modulos = config.modulos
	},

	// mostra carregando ou não
	[types.SET_LOADING]( state, { page, ajax } ){
			 if (page != undefined) {
				 state.loading.page = page
			 }
			 if (ajax != undefined) {
				 state.loading.ajax = ajax
			 }
	},

	// habilita ou desabilita componente global de carregamento
	[types.SET_LOAD_GLOBAL]( state , show){
			if (state.loadGlobal.enable == true) {
					state.loadGlobal.show = show
			}
	},

	[types.SET_VERSAO]( state , {versao}){
		if(versao){
			state.versao = versao;	
		}
	}

}






//



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/config.js